// import RecommendationsApi from '../api/profiles';
import ScoresApi from '../api/scores';
import Recommendations from '../../config/recommendations';

export default {
  namespaced: true,
  state: {
    recommendations: {},
    allValidRecommendations: [],
    audioRecommendations: [],
    visualRecommendations: [],
    transcriptRecommendations: [],
    scoreTable: null,
    languageCodes: {
      English: 'en',
      Finnish: 'fi',
      Swedish: 'sv',
      German: 'de',
      French: 'fr',
      Spanish: 'es',
    },
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
    allValidRecommendations(state) {
      return state.allValidRecommendations;
    },
    audioRecommendations(state) {
      return state.audioRecommendations;
    },
    transcriptRecommendations(state) {
      return state.transcriptRecommendations;
    },
    visualRecommendations(state) {
      return state.visualRecommendations;
    },
    scoreTable(state) {
      return state.scoreTable;
    },
    videoRecommendations(state) {
      return state.videoRecommendations;
    },
    activeFeatures(state) {
      return Object.keys(state.scoreTable);
    },
    languageCodes(state) {
      return Object.values(state.languageCodes);
    },
    languages(state) {
      return Object.keys(state.languageCodes);
    },
    languageCode: state => (language) => {
      return state.languageCodes[language];
    },
    language: state => (languageCode) => {
      // Reversing the language-code object key <-> value :)
      return Object.fromEntries(
        Object.entries(state.languageCodes)
          .map(([key, value]) => [value, key]),
      )[languageCode];
    },
  },
  actions: {
    getAllRecommendations(context) {
      const sorted = {};
      Recommendations.forEach((r) => {
        if (!sorted[r.variable]) {
          sorted[r.variable] = [r];
        } else {
          sorted[r.variable].push(r);
        }
      });
      context.commit('SET_RECOMMENDATIONS', sorted);
      const allFeatures = context.rootGetters['features/allFeatures'];
      const allRecommendations = {
        audio: [],
        transcript: [],
        video: [],
      };
      const allValidRecommendations = [];

      allFeatures.forEach((f) => {
        if (sorted[f.name]) {
          sorted[f.name].forEach((s) => {
            if (f.value >= s.low && s.high >= f.value) {
              allRecommendations[f.type].push(s.recommendation);
              allValidRecommendations.push(s);
            }
          });
        }
      });
      context.commit('SET_ALL_VALID_RECOMMENDATIONS', allValidRecommendations);
      context.commit('SET_AUDIO_RECOMMENDATIONS', allRecommendations.audio);
      context.commit('SET_TRANSCRIPT_RECOMMENDATIONS', allRecommendations.transcript);
      context.commit('SET_VISUAL_RECOMMENDATIONS', allRecommendations.video);
    },
    getVideoRecommendations(context) {
      /* Filter according to intent and results */
      const filtered = [];
      Recommendations.forEach((r) => {
        if (!filtered[r.variable]) {
          filtered[r.variable] = [r];
        } else {
          filtered[r.variable].push(r);
        }
      });
      context.commit('SET_VIDEO_RECOMMENDATIONS', filtered);
    },
    getScoreTable(context) {
      return new Promise(async (resolve) => {
        const sorted = {
          scores: {},
          gradients: {},
          weights: {},
          categories: {},
          displayTypes: {},
        };
        const Scores = await ScoresApi.getScoreIntervals();
        Scores.forEach((n) => {
          n.intervals.forEach((lang) => {
            if (!sorted.scores[lang.language]) {
              sorted.scores[lang.language] = {};
              sorted.gradients[lang.language] = {};
            }
            sorted.scores[lang.language][n.variable] = lang.intervals;
          });
          sorted.weights[n.variable] = n.weight;
          sorted.categories[n.variable] = n.category;
          sorted.displayTypes[n.variable] = n.display_type;
        });
        Object.keys(sorted.scores).forEach((language) => {
          const languageScores = sorted.scores[language];
          Object.keys(languageScores).forEach((key) => {
            if (!sorted.gradients[language][key]) {
              sorted.gradients[language][key] = {
                min: Infinity,
                max: 0,
                steps: [],
              };
            }
            languageScores[key].forEach((entry) => {
              if (sorted.gradients[language][key].min > entry.low) {
                sorted.gradients[language][key].min = entry.low;
              }
              if (sorted.gradients[language][key].max < entry.high) {
                sorted.gradients[language][key].max = entry.high;
              }
              sorted.gradients[language][key].steps.push({
                score: entry.score,
                breakpoint: entry.low,
                percentage: 0,
              });
            });
            /* eslint no-param-reassign: ["error", { "props": false }] */
            Object.keys(sorted.gradients).forEach((lang) => {
              Object.keys(sorted.gradients[lang]).forEach((g) => {
                sorted.gradients[lang][g].steps.forEach((s) => {
                  s.percentage = (
                    ((s.breakpoint - sorted.gradients[lang][g].min) /
                     (sorted.gradients[lang][g].max - sorted.gradients[lang][g].min))
                    * 100
                  ).toFixed(0);
                });
              });
            });
          });
        });
        context.commit('SET_SCORETABLE', sorted);
        const interval = setInterval(() => {
          if (Object.keys(context.state.scoreTable.scores).length > 0) {
            clearInterval(interval);
            resolve(true);
          }
        }, 100);
        resolve(true);
      });
    },
  },
  mutations: {
    SET_RECOMMENDATIONS: (state, recommendations) => {
      state.recommendations = recommendations;
    },
    SET_ALL_VALID_RECOMMENDATIONS: (state, recommendations) => {
      state.allValidRecommendations = recommendations;
    },
    SET_AUDIO_RECOMMENDATIONS: (state, recommendations) => {
      state.audioRecommendations = recommendations;
    },
    SET_VISUAL_RECOMMENDATIONS: (state, recommendations) => {
      state.visualRecommendations = recommendations;
    },
    SET_TRANSCRIPT_RECOMMENDATIONS: (state, recommendations) => {
      state.transcriptRecommendations = recommendations;
    },
    SET_SCORETABLE: (state, scoreTable) => {
      state.scoreTable = scoreTable;
    },
  },
};
